import { render, staticRenderFns } from "./ModuleType.vue?vue&type=template&id=18f9ea3e&scoped=true&"
import script from "./ModuleType.vue?vue&type=script&lang=js&"
export * from "./ModuleType.vue?vue&type=script&lang=js&"
import style0 from "./ModuleType.vue?vue&type=style&index=0&id=18f9ea3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f9ea3e",
  null
  
)

export default component.exports